export default class Toaster {

  /**
   * Show a basic toaster message
   */
	toast(title, message, type) 
	{
 	 	try {
    		$.toaster({
      			title:title, 
      			message:message, 
      			priority:type
    		});
  		} catch (errors) {

    		console.error(errors);
  		
      }
	}


}